import { Config } from "tailwindcss";

export default {
  content: [
    "./src/pages/**/*.{js,jsx,ts,tsx}",
    "./src/components/**/*.{js,jsx,ts,tsx}",
    "./src/contexts/**/*.{js,jsx,ts,tsx}",
    "./src/templates/**/*.{js,jsx,ts,tsx}",
    "./src/utils/tailwind/**/*.{js,jsx,ts,tsx}",
    "./node_modules/react-tailwindcss-datepicker/dist/index.esm.js",
  ],
  darkMode: "class",
  theme: {
    screens: {
      xs: "320px",
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px",
    },
    fontFamily: {
      sans: [
        "NB International Pro",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Oxygen-Sans",
        "Ubuntu",
        "Cantarell",
        "Helvetica Neue",
        "sans-serif",
      ],
    },
    extend: {
      screens: {
        "3xl": "1920px",
      },
      colors: {
        primary: "#006063",
        "primary-lightish": "#B3C6C8",
        "primary-light": "#CBDADB",
        emerald: {
          100: "#CBDADB",
          500: "#006063",
        },
        stone: "#f0523d",
        glass: "#4ac3e0",
        wood: "#d79030",
        materia: "#8282d6",
        metal: "#65554A",
        neutral: "#e6e6e6",
        "neutral-dark": "#878787",
        "neutral-light": "#f4f4f4",
        dark: "black",
        light: "white",
        tooltip: "#4A4A4A",
        "tooltip-dark": "#3E3E3E",
        error: "#E6A0A0",
        "error-light": "#ffebeb",
        "error-dark": "#C90000",
        success: "#94CA93",
        "success-light": "#DEF5DE",
        "success-dark": "#025E00",
        warning: "#C6A278",
        "warning-light": "#fff6eb",
        "warning-dark": "#BB6500",
        info: "#9A9A9A",
        "info-light": "#d9d9d9",
        "info-dark": "#000000",
        "primary-dark": "#122626",
      },
      height: {
        "120": "30rem", // 480px
        "128": "32rem", // 512px
        "136": "34rem", // 544px
        "160": "40rem", // 640px
        "192": "48rem", // 2x384px
      },
      width: {
        "120": "30rem", // 480px
        "128": "32rem", // 512px
        "136": "34rem", // 544px
        "160": "40rem", // 640px
        "192": "48rem", // 2x384px
      },
      minHeight: {
        "120": "30rem", // 480px
        "128": "32rem", // 512px
        "136": "34rem", // 544px
        "160": "40rem", // 640px
        "192": "48rem", // 2x384px
      },
      minWidth: {
        "92": "23rem", // 368px
        "120": "30rem", // 480px
        "128": "32rem", // 512px
        "136": "34rem", // 544px
        "160": "40rem", // 640px
        "192": "48rem", // 2x384px
      },
      borderRadius: {
        "4xl": "40px",
      },
    },
  },
  plugins: [require("gatsby-plugin-postcss")],
} satisfies Config;
